import { render, staticRenderFns } from "./sortBySelect.vue?vue&type=template&id=31c9bd1c&"
import script from "./sortBySelect.vue?vue&type=script&lang=js&"
export * from "./sortBySelect.vue?vue&type=script&lang=js&"
import style0 from "./sortBySelect.vue?vue&type=style&index=0&id=31c9bd1c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports